import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/invoice-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IInvoice } from 'src/types/invoice';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    files: any;
    invoice: Partial<IInvoice> | null;
}

export interface DispatchProps {
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InvoiceInfo: React.FunctionComponent<Props> = ({
    invoice,
    getData,
    getFiles,
    files,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, getFiles]);

    if (!invoice) {
        return null;
    }

    const previewFiles =
        files &&
        files.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    {file.name}
                </a>
            </li>
        ));
    return (
        <RoleLayout>
            <div>
                <h2>INVOICES {`>`} INVOICE</h2>
            </div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'Documents:'} value={previewFiles} />
                </div>

                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.INVOICE_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </RoleLayout>
    );
};

export default InvoiceInfo;
